import {
  getLandingActivity,
  getSignupActivity,
} from "@faire/deprecated-retailer-visitor-shared/actions/user/recordLoggedOutActivity";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";

export const getPreSignUpActivities = (signUpSource: string = "") => {
  const preSignUpActivities = [
    getLandingActivity(),
    getSignupActivity(signUpSource),
  ].filter(isNotUndefined);
  return preSignUpActivities.length ? preSignUpActivities : undefined;
};
